import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import { emptyValueToDash } from '../utils/values';
import PropTypesPresenter from '../utils/PropTypesPresenter';
import UserPresenter from '../presenters/UserPresenter';
import CashbackPresenter from '../presenters/CashbackPresenter';
import SourceDataPresenter from '../presenters/Transaction/SourceDataPresenter';
import BankAccountPresenter from '../presenters/BankAccountPresenter';

export const ACTIVE = 'active';
export const ARCHIVED = 'archived';
export const STATES = [ACTIVE, ARCHIVED];
const PENDING = 'pending';
const ALL = 'all';
const IN_MALL = 'in_mall';
const OUT_OF_MALL = 'out_of_mall';
export const LOCATIONS = {
  all: ALL,
  inMall: IN_MALL,
  outOfMall: OUT_OF_MALL,
};

const ACTION_REQUIRED = 'action_required';
const PROCESSED = 'processed';
const CHECKED = 'checked';

export const REFUND_STATUSES = {
  actionRequired: ACTION_REQUIRED,
  processed: PROCESSED,
  checked: CHECKED,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    date: PropTypes.string,
    storeName: PropTypes.string,
    location: PropTypes.string,
    merchantName: PropTypes.string,
    amount: PropTypes.number,
    status: PropTypes.string,
    cashbackRate: PropTypes.string,
    storeId: PropTypes.string,
    isoCurrencyCode: PropTypes.string,
    plaidTransactionId: PropTypes.string,
    paymentChannel: PropTypes.string,
    transactionType: PropTypes.string,
    category: PropTypes.string,
    categoryId: PropTypes.string,
    paymentMeta: PropTypes.string,
    userEmail: PropTypes.string,
    userAuth0Id: PropTypes.string,
    cashbackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    state: PropTypes.string,
    plaidBankAccountId: PropTypes.string,
    relatedPurchaseId: PropTypes.number,
    inMall: PropTypes.bool,
    duplicationState: PropTypes.string,
    refundGroupId: PropTypes.number,
    refundStatus: PropTypes.string,
    purchaseGroupId: PropTypes.number,
    user: UserPresenter.shape(),
    cashback: CashbackPresenter.shape(),
    sourceData: SourceDataPresenter.shape(),
    bankAccount: BankAccountPresenter.shape(),
  },
  {
    dateFormat(transaction) {
      return this.date(transaction).replaceAll('-', '/');
    },
    isTransactionWithCashback(transaction) {
      return !isNil(this.cashbackRate(transaction));
    },
    hasTransactionRelatedPurchase(transaction) {
      return !isNil(this.relatedPurchaseId(transaction));
    },
    displayedCashbackRate(transaction) {
      if (!this.isTransactionWithCashback(transaction)) return '--';

      return `${this.cashbackRate(transaction)}%`;
    },
    amountReadable(transaction) {
      return `$${this.amount(transaction)}`;
    },
    isPending(transaction) {
      return this.status(transaction) === PENDING;
    },
    isActive(transaction) {
      return this.state(transaction) === ACTIVE;
    },
    isArchived(transaction) {
      return this.state(transaction) === ARCHIVED;
    },
    stateReadable(transaction) {
      const stateMap = {
        [ACTIVE]: 'Active',
        [ARCHIVED]: 'Archived',
      };
      const state = this.state(transaction);

      return stateMap[state];
    },

    refundStatusReadable(transaction) {
      const statusMap = {
        [ACTION_REQUIRED]: 'Action Required',
        [PROCESSED]: 'Processed',
        [CHECKED]: 'Checked',
      };
      const refundStatus = this.refundStatus(transaction);

      return statusMap[refundStatus] || '--';
    },
    refundGroupIdReadable(transaction) {
      const refundGroupId = this.refundGroupId(transaction);
      return emptyValueToDash(refundGroupId);
    },
    isRefund(transaction) {
      const amount = this.amount(transaction);

      return amount < 0.0;
    },
  }
);
